export const batteryCritical = (car, siteSettingsData) => {
  let batteryLevel = {
    warning: 25,
    critical: 10
  };
  return siteSettingsData?.GuardianCapable && !car.IsCharging && (car.BatteryLevel <= batteryLevel.critical);
};